import { render, staticRenderFns } from "./QuickMenu.vue?vue&type=template&id=2ce0896a&"
import script from "./QuickMenu.vue?vue&type=script&lang=ts&"
export * from "./QuickMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports